export const SET_TERMS_OF_USE_ACCEPTED = 'SET_TERMS_OF_USE_ACCEPTED';
export const SET_SHOW_PAYPAL_OVERLAY = 'SET_SHOW_PAYPAL_OVERLAY';

export function setTermsOfUseAccepted(accepted) {
    return {
        type: SET_TERMS_OF_USE_ACCEPTED,
        payload: { termsOfUseAccepted: accepted }
    };
}
